import rpc from '@square/dashboard-utilities/clients/rpc';
import { FlagsService } from '@square/ember-features/protos/squareup/feature/relay/flags/service';
import { baseConnectUrl } from '@square/dashboard-utilities/utils/url';
export const GET_FLAGS_URL = '/1.0/features/get-flags';
export const GET_FLAGS_SANDBOX_URL = '/1.0/features/get-flags-sandbox';
export const HEADERS = new Map();
function urlForMethod(method, guessedUrl) {
  switch (method) {
    case FlagsService.methods.GetFlags:
      return baseConnectUrl(GET_FLAGS_URL, true);
    case FlagsService.methods.GetFlagsSandbox:
      return baseConnectUrl(GET_FLAGS_SANDBOX_URL, true);
    default:
      return guessedUrl;
  }
}
export default FlagsService.create(rpc(urlForMethod, {
  additionalHeaders: HEADERS
}));